import { action } from '@ember/object';
import { service } from '@ember/service';
import Component from '@glimmer/component';
import { tracked } from 'tracked-built-ins';
// @ts-ignore
import type CookiesService from 'ember-cookies';
import type HeadDataService from 'frontend/services/head-data';

interface CookieBannerArgs {}

export default class CookieBannerComponent extends Component<CookieBannerArgs> {
  @service declare cookies: CookiesService;
  @service declare headData: HeadDataService;
  @tracked cookieStrictlyNecessary = true;
  @tracked cookieTier = false;
  @tracked showModal = false;
  @tracked showBanner = false;

  constructor(owner: unknown, args: CookieBannerArgs) {
    super(owner, args);
    if (!this.cookies.exists('moove_gdpr_popup')) {
      this.showBanner = true;
    }
  }

  @action
  updatePreference(
    cookie: 'cookieStrictlyNecessary' | 'cookieTier',
    value?: boolean
  ) {
    this[cookie] = value !== undefined ? value : !this[cookie];
  }
  @action
  toggleModal() {
    this.showModal = !this.showModal;
  }
  @action
  acceptCookies(fromBanner?: boolean) {
    if (fromBanner) {
      this.cookieTier = true;
    }
    if (this.cookieTier) {
      this.cookies.write(
        'moove_gdpr_popup',
        JSON.stringify({ strict: '1', thirdparty: '1', advanced: '1' })
      );
      this.headData.hasCookieForAnalytics = true;
    } else {
      this.cookies.write(
        'moove_gdpr_popup',
        JSON.stringify({ strict: '1', thirdparty: '0', advanced: '0' })
      );
    }
    this.hideBanner();
  }
  @action
  rejectCookies() {
    this.cookieTier = false;
    this.cookies.write(
      'moove_gdpr_popup',
      JSON.stringify({
        strict: '1',
        thirdparty: '0',
        advanced: '0',
      })
    );
    this.hideBanner();
  }

  private hideBanner() {
    this.showBanner = false;
  }
}
